import React, { useState } from 'react';

import classNames from 'classnames/bind';
import style from './styles.module.scss';

const cx = classNames.bind(style);

function Button({
  type,
  disabled = false,
  onClick,
  text = '',
  lineType = false,
  fillType = false,
  children,
  style,
  ...props
}) {
  return (
    <button
      className={cx(
        type,
        fillType && `fill-${fillType}`,
        lineType && `line-${lineType}`,
        props.fullWidth && 'full-width',
        disabled && `${type}-disabled`,
        props.textType,
      )}
      onClick={onClick}
      style={style}
    >
      {children}
    </button>
  );
}
export default Button;
